import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import { getTruncatedString } from '../../utils/string'

export default class IntendedCourseLevel extends Component {
  render() {
    const { quest } = this.props

    return (
      <div className="intended-course-level-container">
        <ReactTooltip
          key={quest.mock_level ? `level-${quest.id}` : `no-level-${quest.id}`}
          id="levelTooltip"
          effect="solid"
          offset={{ bottom: 5 }}
        />
        <ReactTooltip
          id="intendedTooltip"
          effect="solid"
          offset={{ bottom: 5 }}
        />

        <div className="course-container">
          <div
            className="course"
            style={{ color: `#${quest.mock_course.color}` }}
          >
            {quest.mock_course.name}
          </div>
        </div>

        <div className="level-container">
          {quest.mock_level ? (
            <div className="level">
              {quest.mock_level.mastery ? (
                <div
                  data-for="levelTooltip"
                  data-tip={getTruncatedString({
                    val: `Mastery Level: ${quest.mock_level.name}`,
                    len: 107
                  })}
                >
                  Mastery Level
                </div>
              ) : (
                <div
                  data-for="levelTooltip"
                  data-tip={getTruncatedString({
                    val: `Level ${quest.mock_level.number}: ${quest.mock_level.name}`,
                    len: 107
                  })}
                >
                  Level {quest.mock_level.number}
                </div>
              )}
            </div>
          ) : (
            <div
              className="level"
              data-for="levelTooltip"
              data-tip="No Intended Level has been added."
            >
              Level: Not Yet Specified
            </div>
          )}
          <div
            className="level intended"
            data-for="intendedTooltip"
            data-tip="This is the intended Journey and Level for this quest."
          >
            (Intended)
          </div>
        </div>
      </div>
    )
  }
}

IntendedCourseLevel.propTypes = {
  quest: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/mini/IntendedCourseLevel.js